import { useEffect } from 'react'

/**
 * Imperatively set `document.title` for a route that renders no `<title>` of its
 * own — the authenticated workspace, admin, and the auth flow. React updates the
 * tab title only for a page that renders one, so a title-less page would keep the
 * previous page's (or, in dev where no prerender runs, `__SITE_TITLE__` raw).
 *
 * Never call it from a page whose `meta()` or `CalculatorPageWrapper` sets the
 * title: React forbids two simultaneous sources and the result is undefined.
 * `undefined`/empty leaves the current title untouched.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (title) document.title = title
  }, [title])
}
